import React from 'react';

const IconlyRegularBoldCategory = ({ width = 20, height = 20, fill = "#D9D9D9" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M3.784 1.667H6.6c1.175 0 2.117.958 2.117 2.134v2.84A2.118 2.118 0 0 1 6.6 8.776H3.784a2.123 2.123 0 0 1-2.117-2.133V3.8c0-1.176.95-2.134 2.117-2.134Zm0 9.558H6.6c1.175 0 2.117.95 2.117 2.134v2.84A2.123 2.123 0 0 1 6.6 18.334H3.784A2.129 2.129 0 0 1 1.667 16.2v-2.841c0-1.183.95-2.134 2.117-2.134Zm12.433-9.558H13.4A2.123 2.123 0 0 0 11.284 3.8v2.84c0 1.184.941 2.134 2.116 2.134h2.817c1.167 0 2.117-.95 2.117-2.133V3.8c0-1.176-.95-2.134-2.117-2.134ZM13.4 11.225h2.817c1.167 0 2.117.95 2.117 2.134v2.84c0 1.176-.95 2.134-2.117 2.134H13.4a2.123 2.123 0 0 1-2.116-2.133v-2.841c0-1.183.941-2.134 2.116-2.134Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyRegularBoldCategory;